import { Layout, Text } from '@loadsmart/miranda-react'

import { type TrackingProvider } from '../../../domain/Tracking'
import { formatTrackingProviderName } from '../../../presenters/preferredTrackingMethod'
import { ProvidersBadge } from '../ProvidersBadge'
import SelectableBox from './SelectableBox'

export type TrackingProviderCardCardProps = {
  readonly provider: TrackingProvider
  readonly selected?: boolean
  readonly onClick: () => void
}

export default function TrackingProviderCard({
  provider,
  selected = false,
  onClick,
}: TrackingProviderCardCardProps) {
  return (
    <SelectableBox selected={selected} onClick={onClick}>
      <Layout.Stack align="center" gap="spacing-2">
        <ProvidersBadge providers={[provider]} />
        <Text variant="body-sm" color="color-text-tertiary">
          {formatTrackingProviderName(provider)}
        </Text>
      </Layout.Stack>
    </SelectableBox>
  )
}
